/* BY BLOOM winkelwagen: gratis-verzendbalk, vertrouwensregel en prijs zonder "EUR" */
(function () {
  var FREE = 4500; // gratis verzending vanaf €45 (in centen)
  var LOCK = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>';
  function fmt(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }
  function setHTML(el, html) { if (el.innerHTML !== html) el.innerHTML = html; }
  function stripEur() {
    document.querySelectorAll('#CartDrawer .totals__total-value, #main-cart-footer .totals__total-value, product-info .price-item, .card-information .price-item, .related-products .price-item').forEach(function (el) {
      var t = el.textContent.replace(/\s*EUR\s*$/, '').trim();
      if (el.textContent.trim() !== t) el.textContent = t;
    });
  }
  function enhance() {
    stripEur();
    var inner = document.querySelector('#CartDrawer .drawer__inner');
    if (inner) {
      var ctas = inner.querySelector('.cart__ctas');
      if (ctas && !inner.querySelector('.bb-trust')) {
        var p = document.createElement('p');
        p.className = 'bb-trust';
        p.innerHTML = LOCK + 'Veilig afrekenen · Vóór 15:00 besteld, vandaag verzonden';
        ctas.insertAdjacentElement('afterend', p);
      }
    }
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inner2 = document.querySelector('#CartDrawer .drawer__inner');
        if (!inner2) return;
        var bar = inner2.querySelector('.bb-ship');
        if (!cart.item_count) { if (bar) bar.remove(); return; }
        var hdr = inner2.querySelector('.drawer__header');
        if (!hdr) return;
        if (!bar) {
          bar = document.createElement('div');
          bar.className = 'bb-ship';
          bar.innerHTML = '<p class="bb-ship__txt"></p><span class="bb-ship__bar"><i></i></span>';
          hdr.insertAdjacentElement('afterend', bar);
        }
        var left = FREE - cart.total_price;
        var pct = Math.max(4, Math.min(100, Math.round(cart.total_price / FREE * 100)));
        setHTML(bar.querySelector('.bb-ship__txt'), left > 0
          ? 'Nog <b>' + fmt(left) + '</b> tot <b>gratis verzending</b>'
          : '<b>Je hebt gratis verzending</b> ✓');
        bar.querySelector('i').style.width = pct + '%';
        bar.classList.toggle('is-free', left <= 0);
      })
      .catch(function () {});
  }
  var t;
  function schedule() { clearTimeout(t); t = setTimeout(enhance, 120); }
  function init() {
    enhance();
    var d = document.querySelector('cart-drawer');
    if (d && window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var n = muts[i].target;
          if (n.closest && (n.closest('.bb-ship') || n.closest('.bb-trust'))) continue;
          schedule(); return;
        }
      }).observe(d, { childList: true, subtree: true });
    }
    var f = document.getElementById('main-cart-footer');
    if (f && window.MutationObserver) new MutationObserver(stripEur).observe(f, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
